import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';

import { OverlayLoadingService } from './loading-overlay-manager';
import { SKIP_LOADING } from './loading-context';

/**
 * Global loading overlay interceptor.
 *
 * Shows the global overlay for all HttpClient requests unless opted out via SKIP_LOADING.
 */
export const loadingOverlayInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_LOADING) === true) {
    return next(req);
  }

  const overlay = inject(OverlayLoadingService);
  const timeoutId = overlay.showWithDelay();
  return next(req).pipe(finalize(() => overlay.hide(timeoutId)));
};
